import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, ChevronRight, Calculator, Loader2 } from 'lucide-react';
import { expensasPortalApi } from '../../lib/api';

const ORDEN = ['Torre Emilia', 'Foresta'];

export default function InquilinoExpensas() {
  const [unidades, setUnidades] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    expensasPortalApi.misUnidades()
      .then((r) => setUnidades(r.data || []))
      .catch(() => setUnidades([]))
      .finally(() => setLoading(false));
  }, []);

  const porEdificio = {};
  for (const u of unidades) {
    const k = u.edificio_nombre || 'Otros';
    (porEdificio[k] = porEdificio[k] || []).push(u);
  }
  const edificios = Object.keys(porEdificio).sort((a, b) => {
    const ia = ORDEN.indexOf(a), ib = ORDEN.indexOf(b);
    if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    return a.localeCompare(b);
  });

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto" data-testid="inquilino-expensas">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-xl bg-indigo-100 flex items-center justify-center">
          <Calculator className="w-5 h-5 text-indigo-700" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Expensas</h1>
          <p className="text-slate-500 text-sm">Unidades a tu cargo</p>
        </div>
      </div>

      {loading ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
      ) : unidades.length === 0 ? (
        <div className="bg-white border border-dashed border-slate-300 rounded-xl p-12 text-center text-slate-400">
          No tenés unidades con expensas a tu cargo por el momento.
        </div>
      ) : (
        <div className="space-y-6">
          {edificios.map((ed) => (
            <div key={ed} data-testid={`inq-edificio-${ed}`}>
              <div className="flex items-center gap-2 mb-2">
                <Building2 className="w-4 h-4 text-[#1B4D3E]" />
                <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">{ed}</h3>
                <span className="text-xs text-slate-400">({porEdificio[ed].length})</span>
              </div>
              <div className="bg-white border border-slate-200 rounded-lg overflow-hidden divide-y divide-slate-100">
                {porEdificio[ed].map((u) => (
                  <Link key={u.unidad_id} to={`/inquilino/expensas/${u.unidad_id}`}
                    className="flex items-center justify-between gap-4 px-5 py-4 hover:bg-slate-50 transition-colors"
                    data-testid={`inq-unidad-${u.unidad_id}`}>
                    <span className="text-sm font-semibold text-slate-900">{u.nombre_unidad}</span>
                    <span className="inline-flex items-center gap-1 text-sm font-medium text-[#1B4D3E] bg-[#1B4D3E]/10 rounded px-3 py-1.5">
                      Ver más <ChevronRight className="w-4 h-4" />
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
